import styled from 'styled-components';
import BottomModal from '../../../components/modal/BottomModal';
import DatePicker from '../../../components/calendar/DatePicker';
import { useState } from 'react';

interface Props {
  date: string;
  setDate: (s: string) => void;
  onClose: () => void;
  minDate?: string;
  maxDate?: string;
}

function CalendarModal({ date, setDate, onClose, minDate, maxDate }: Props) {
  const [selected, setSelected] = useState(date);

  const handleClickReset = () => {
    setSelected('');
  };

  const handleClickApply = () => {
    setDate(selected);
    onClose();
  };
  return (
    <BottomModal onClose={onClose}>
      <Header>
        <Title>매각기일</Title>
        <CloseButton
          src="/assets/images/close/close-black.svg"
          alt="close"
          onClick={onClose}
        />
      </Header>
      <Content>
        <DatePicker
          selected={selected}
          setSelected={setSelected}
          minDate={minDate}
          maxDate={maxDate}
        />
      </Content>
      <ButtonGroup>
        <ResetButton
          onClick={() => {
            handleClickReset();
          }}
        >
          초기화
        </ResetButton>
        <ApplyButton onClick={handleClickApply}>적용</ApplyButton>
      </ButtonGroup>
    </BottomModal>
  );
}

export default CalendarModal;

const Header = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const Title = styled.div`
  flex: 1 0 0;
  color: #222;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;
const CloseButton = styled.img`
  position: absolute;
  right: 16px;
  top: 17px;
  cursor: pointer;
`;

const Content = styled.div`
  display: flex;
  height: 505px;
  padding: 16px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const ButtonGroup = styled.div`
  padding: 16px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const Button = styled.button`
  border: none;
  outline: none;

  display: flex;
  padding: 12px 28px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const ResetButton = styled(Button)`
  color: #616161;
  background: rgba(112, 115, 124, 0.08);
`;

const ApplyButton = styled(Button)`
  flex: 1 0 0;
  background: #008aff;
  color: #fff;
`;
